const asText = (value) => (value == null ? "" : String(value).trim());

// Normalize geolocation to a single canonical shape: { latitude, longitude }
// at the top level of the card. Three sources are observed in the data:
//   1. top-level `geolocation` (canonical schema)
//   2. flat `identity.address.latitude` + `identity.address.longitude` (legacy)
//   3. nested `identity.address.geolocation` (legacy, none in current data)
// Strip every legacy copy from the address so downstream code reads `card.geolocation`.
const normalizeGeolocation = (property, rawAddress) => {
  const candidates = [
    property?.geolocation,
    rawAddress?.geolocation,
    { latitude: rawAddress?.latitude, longitude: rawAddress?.longitude },
  ];
  for (const geo of candidates) {
    const lat = Number(geo?.latitude);
    const lng = Number(geo?.longitude);
    if (Number.isFinite(lat) && Number.isFinite(lng)) return { latitude: lat, longitude: lng };
  }
  return null;
};

// Canonical ZIP: trimmed, lowercased, ZIP+4 suffix stripped. Empty → "".
const normalizeZip = (rawAddress) =>
  String(rawAddress?.zip || "").trim().toLowerCase().split("-")[0];

export const toPropertyCard = (property) => {
  const identity = property?.identity || {};
  const rawAddress = identity?.address || {};
  const { geolocation: _g, latitude: _lat, longitude: _lng, zip: _z, ...address } = rawAddress;
  const details = property?.details || {};
  return {
    id: property?.id || "",
    name: asText(property?.name),
    status: asText(property?.status),
    state: asText(property?.state),
    category: asText(property?.category),
    domain: asText(property?.domain),
    identity: { apn: asText(identity.apn), address },
    geolocation: normalizeGeolocation(property, rawAddress),
    zip: normalizeZip(rawAddress),
    details,
    updatedAt: property?.updatedAt || property?.createdAt || "",
  };
};

// Blank property used by the "+" add flows (Properties page and the contact's
// linked-properties panel). `_isNew` tells the save handler to create.
export const EMPTY_PROPERTY_DRAFT = {
  name: "New Property",
  status: "",
  category: "",
  identity: { apn: "", address: { streetNo: "", streetName: "", unit: "", city: "", state: "CA", zip: "", county: "" } },
  details: {},
};

export const newPropertyDraft = () => ({ id: `draft-${Date.now()}`, ...EMPTY_PROPERTY_DRAFT, _isNew: true });
